<script>
import { list } from '@/api/grupopessoa'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ grupo: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="grupo"
    width="1000"
    component="app-grupopessoa-grid"
    label="Grupo Pessoa"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
